import { Component, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { IConfig } from 'ngx-countries-dropdown';
import { OtpService } from '../../providers/services/otp.service';
import { UserContextService } from '../../providers/services/user-context.service';
import { isTabView } from '../../utils';
import { NEW_USER } from '../../constants/helper-constant';
import { AuthServiceHelper } from '../../providers/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  public userInput: string = '';
  public isLoading: boolean = false;
  public validationError: string = '';
  public isInputFocused: boolean = false;
  public isPhoneInput: boolean = false;
  public timezone: string = 'Asia/Calcutta';
  public selectedCountryCode: string = '';
  public countryList: any[] = [
    { name: 'India', code: '+91' },
    { name: 'USA', code: '+1' },
  ];
  public isValidInput: any;
  public lastSelectedCountryCode: string = 'in';
  public countryDialingCode: string = '+91';
  public verificationError: string = '';
  public otpDigits: string[] = ['', '', '', ''];
  public isVerifying: boolean = false;
  public otpverification = false;
  public userContext: {
    contact: string;
    contactType: 'phone' | 'email';
    countryDialingCode?: string;
    countryCode?: string;
  } | null = null;
  public countdown: number = 60;
  public interval: any;
  public showResend: boolean = false;
  public contact: string | undefined;
  public isTabView: boolean;
  public selectedCountryConfig: IConfig = {
    hideCode: true,
    hideName: true,
    hideFlag: false,
  };
  public countryListConfig: IConfig = {
    hideCode: true,
    hideFlag: false,
  };
  public isFocused: boolean = false;
  public newUser: boolean = false;
  public cred!: any;
  @ViewChild('otpInput1') otpInput1!: Input;
  @ViewChild('otpInput2') otpInput2!: Input;
  @ViewChild('otpInput3') otpInput3!: Input;
  @ViewChild('otpInput4') otpInput4!: Input;

  constructor(
    private router: Router,
    private otpService: OtpService,
    private userContextService: UserContextService,
    private activatedRoute: ActivatedRoute,
    public authService: AuthServiceHelper
  ) {
    this.isTabView = isTabView();
    this.timezone = this.getTimezone();
    this.cred = this.activatedRoute.snapshot.queryParams['cred'];
  }


  public ngAfterViewInit() {
    this.userInput = this.activatedRoute.snapshot.queryParams['emailId'];
    this.otpverification = this.activatedRoute.snapshot.queryParams['otp'];
    this.cred = this.activatedRoute.snapshot.queryParams['cred'];
    this.userContext = this.userContextService.getContact();
    this.contact = this.userContext?.contact;
    localStorage.removeItem(NEW_USER);
  }
  /**
   * @function onCountryChange
   * validateForm method used to change country code
   */
  public onCountryChange(event: any) {
    this.countryDialingCode = event.dialling_code;
    this.lastSelectedCountryCode = event.code;
    this.onInputFocus();
  }

  /**
   * @function onInputFocus
   * validateForm method used to input focus
   */
  public onInputFocus() {
    this.isInputFocused = true;
  }

  /**
   * @function onInputBlur
   * validateForm method used to blur the input
   */
  public onInputBlur() {
    this.isInputFocused = false;
  }

  /**
   * @function getTimezone
   * validateForm method used to timezone
   */
  public getTimezone() {
    return Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
  }

  /**
   * @function onUserInputChange
   * validateForm method used to detect user input change
   */
  public onUserInputChange() {
    this.validationError = '';
    const trimmedInput = this.userInput.trim();
    if (trimmedInput === '') {
      this.isValidInput = false;
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.timezone = this.getTimezone();
    if (this.timezone !== 'Asia/Calcutta') {
      this.isPhoneInput = false;
      this.isValidInput = emailRegex.test(trimmedInput);
    } else {
      this.isPhoneInput = /^\d+$/.test(trimmedInput);
      this.isValidInput = this.isPhoneInput
        ? trimmedInput.length >= 10 && trimmedInput.length <= 15
        : emailRegex.test(trimmedInput);
    }
  }

  /**
   * @function sendOtp
   * validateForm method used to send OTP
   */
  public async sendOtp() {
    this.isLoading = true;
    const trimmedInput = this.userInput.trim();
    const isPhone = /^\d{10,15}$/.test(trimmedInput); // You can adjust the length limits
  
    // Email Regex (simplified)
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedInput);

    if (trimmedInput) {
      const isValidUsername = await this.otpService.checkUsernameIsValid(trimmedInput);
      if (!isValidUsername) {
        if (!isPhone && !isEmail) {
          this.validationError = 'Please enter a valid username, email or phone number.';
          this.isLoading = false;
          return;
        }
      }
    }    

    this.validationError = ''; // Clear any previous error
  
    this.userContextService.setContact({
      contact: trimmedInput,
      contactType: isPhone ? 'phone' : 'email',
      ...(isPhone && {
        countryDialingCode: this.countryDialingCode,
        countryCode: this.lastSelectedCountryCode,
      }),
    });
  
    this.userContext = this.userContextService.getContact();
    this.contact = this.userContext?.contact;
  
    const request = isPhone
      ? { phone: `${this.countryDialingCode}${trimmedInput}` }
      : { email: trimmedInput };
  
    this.otpService.sendOtp(request)
      .then((data) => {
        this.newUser = data?.newUser;
        this.isLoading = false;
        this.startCountdown();
  
        if (data?.response?.length) {
          this.router.navigate(['/tenant-list'], {
            queryParams: { emailId: trimmedInput },
          });
          localStorage.setItem('tenantEmail', trimmedInput);
        } else if (data?.response?.status === 201) {
          this.otpverification = true;
          if (data?.accounts?.length === 1) {
            this.cred = data?.accounts[0].cred;
          }
          setTimeout(() => {
            const firstInput = document.getElementById('otpInput0') as HTMLInputElement;
            firstInput?.focus();
          });
        }
      })
      .catch((error) => {
        this.isLoading = false;
        this.validationError =
          error?.error?.message || 'Failed to send OTP. Please try again.';
      });
  }  

  /**
   * @function onOtpDigitInput
   * validateForm method used to otp input
   */
  public onOtpDigitInput(event: any, index: number): void {
    const input = event.target;
    const value = input.value;
    if (!/^[0-9]$/.test(value)) {
      this.otpDigits[index] = '';
      return;
    }
    if (index < 3 && value) {
      const nextInput = document.getElementById(
        `otpInput${index + 1}`
      ) as HTMLInputElement;
      nextInput?.focus();
    }
    const allDigitsEntered = this.otpDigits.every((d) => /^\d$/.test(d));
    if (allDigitsEntered) {
      this.verifyOTP();
    }
  }

  /**
   * @function moveFocus
   * validateForm method used to otp focus
   */
  public moveFocus(index: number): void {
    const nextField = document.getElementById(`otpInput${index}`);
    if (nextField) {
      (nextField as HTMLInputElement).focus();
    }
  }

  /**
   * @function onKeyDown
   * validateForm method used to detect keyborad keys
   */
  public onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && this.otpDigits[index] === '') {
      if (index > 0) {
        this.moveFocus(index - 1);
      }
    }
    const regex = /^[0-9]$/;
    if (!regex.test(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
    if (event.key === 'Enter' && !this.isFormInvalid()) {
      this.verifyOTP();
    }
  }

  /**
   * @function handlePaste
   * validateForm method used to handle copy paste
   */
  public handlePaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 4);
    this.otpDigits = digits.split('');
    event.preventDefault();
  }

  /**
   * @function verifyOTP
   * validateForm method used to verify OTP
   */
  public verifyOTP() {
    this.verificationError = '';
    const otp = this.otpDigits.join('');
    if (otp.length !== 4) {
      console.error('Invalid OTP length');
      return;
    }
    this.isVerifying = true;
    const userContext = this.userContextService.getContact();
    if (!userContext) {
      console.error('No user context found');
      return;
    }
    const verifyPayload: any = {
      otp,
      ...(userContext.contactType === 'phone'
        ? { phoneNumber: `${this.countryDialingCode}${this.userInput.trim()}` }
        : { email: this.userInput }),
    };
    this.otpService
      .verifyOtp(verifyPayload)
      .then(() => {
        if(verifyPayload?.email && this.newUser) {
          localStorage.setItem(NEW_USER, 'true');
        }
        this.otpService.loggedIn();
        setTimeout(() => {
          this.router.navigate(['/home'], {
            queryParams: {
              cred: this.cred,
            },
          });
          this.isVerifying = false;
        }, 1000);
      })
      .catch((error) => {
        console.error('OTP verification failed', error);
        this.isVerifying = false;
        this.verificationError =
          error?.error?.message || 'Invalid OTP. Please try again.';
        this.otpDigits = ['', '', '', ''];
        setTimeout(() => {
          const firstInput = document.getElementById('otpInput0') as HTMLInputElement;
          firstInput?.focus();
        });
      });
  }

  /**
   * @function isFormInvalid
   * validateForm method used to check otp valid
   */
  public isFormInvalid(): boolean {
    return this.otpDigits.some((field) => field.length !== 10);
  }

  /**
   * @function goBack
   * validateForm method used to navigate back
   */
  public goBack() {
    this.otpverification = false;
  }

  /**
   * @function startCountdown
   * validateForm method used to start resend countdown
   */
  public startCountdown() {
    this.showResend = false;
    this.countdown = 60;

    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.showResend = true;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  /**
   * @function resendOTP
   * validateForm method used to resend OTP
   */
  public async resendOTP() {
    this.startCountdown();
    const userContext = this.userContextService.getContact();
    if (!userContext) {
      console.error('No user context found');
      return;
    }
    const otpPayload =
      userContext.contactType === 'phone'
        ? { phone: `${this.countryDialingCode}${this.userInput}` }
        : { email: this.userInput };
    await this.otpService.sendOtp(otpPayload);
  }
}
